import { Container } from 'unstated'
import {
  addToWishlist,
  cancelRegistration,
  enrollRecordedRequest,
  enrollRequest,
  initCourse,
  removeFromWishlist,
} from '../../../API/Course'
import { allowJoinClass, classesToArray } from '../Helpers/Timings'
import { resetState } from '../../../Helpers/Misc'
import { updateCourseDetailsAdmin } from '../../../API/Admin'
import { debounce } from 'throttle-debounce'
import { followTeacherRequest, unfollowTeacher } from '../../../API/Teacher'
import ReactPixel from 'react-facebook-pixel'
import { getPriceFromMatrix } from '../../../Helpers/Price'

const initialState = () => ({
  loading: true,
  loadFailed: false,
  userType: 'anonymous',
  teacher: {
    name: '',
    id: '',
  },
  name: '',
  objectives: '',
  preRequisites: '',
  enrollments: [],
  description: '',
  instruments: [],
  fee: {},
  type: 'live',
  id: '',
  chapters: [],
  cover: '',
  noOfClasses: 0,
  rating: 0,
  wishListed: false,
  showEnrollmentRequestModal: true,
  enrollmentSlots: [],
  admin: false,
})

export default class CourseStore extends Container {
  name = 'CourseStore'

  state = initialState()
  updateCourseDataAdmin = debounce(500, async (updates) => {
    const {
      id: courseID,
      teacher: { id: teacherID },
    } = this.state

    return await updateCourseDetailsAdmin(updates, courseID, teacherID)
  })

  init = async ({ livDemyID, courseURL, user, admin }) => {
    await this.setState({
      ...resetState(this.state, initialState()),
      user,
      courseURL,
      livDemyID,
      admin,
    })

    const courseData = await initCourse(courseURL, livDemyID)
    if (courseData) {
      const userType = (() => {
        if (!user || !user.id) {
          return 'anonymous'
        } else if (user.id === courseData.teacher.id) {
          return 'teacher'
        } else if (user.id && courseData.enrollments.length) {
          return 'student'
        }
        return 'notEnrolled'
      })()

      courseData.fee = courseData.stdFee = getPriceFromMatrix(
        courseData.priceMatrix,
        courseData.fee,
      )

      // if (courseData.fee.currency !== localCurrency) {
      //   const exr = await getExchangeRate(
      //     localCurrency,
      //     courseData.fee.currency
      //   );

      //   courseData.stdFee = {
      //     currency: localCurrency,
      //     amount: (parseFloat(courseData.fee.amount) / exr).toFixed(0),
      //   };
      // } else {
      //   courseData.stdFee = courseData.fee;
      // }

      courseData.allEnrollments = courseData.enrollments
      if (courseData.type === 'recorded') {
        const paidEnrollment = courseData.enrollments.find(
          (enrollment) => enrollment?.status === 'PAID',
        )
        if (paidEnrollment) {
          courseData.enrollments = [paidEnrollment]
        }
      }
      await this.setState({ ...courseData, userType, loading: false })
    } else {
      await this.setState({ loading: false, loadFailed: true })
      return false
    }

    return true
  }

  wishlist = async () => {
    const { id, wishListed } = this.state
    if (wishListed) {
      const success = await removeFromWishlist(id)
      if (success) {
        await this.setState({ wishListed: false })
      }
    } else {
      const success = await addToWishlist(id)
      if (success) {
        ReactPixel.track('AddToWishlist', { content_ids: [id] })
        await this.setState({ wishListed: true })
      }
    }
  }

  initiateEnrollmentRequest = async (slots) => {
    const { noOfClasses } = this.state
    if (!(slots.length === noOfClasses)) {
      return false
    }
    await this.setState({ enrollmentSlots: slots })
    return true
  }

  enroll = async (message, batchId, auditionVideo) => {
    const { id, enrollmentSlots, isGroupCourse } = this.state

    return await enrollRequest(
      id,
      isGroupCourse
        ? auditionVideo
          ? { note: message, batchId, auditionVideo }
          : { note: message, batchId }
        : {
            note: message,
            dateSlots: enrollmentSlots,
          },
    )
  }

  enrollRecorded = async (type = 'STANDARD') => {
    const { id, user, courseURL, livDemyID, admin } = this.state

    const success = await enrollRecordedRequest(id, type)

    if (success) {
      this.init({ user, courseURL, livDemyID, admin })
    }

    return success
  }

  getUpcomingClass = () => {
    const { enrollments, userType } = this.state

    const allClasses = enrollments.reduce(
      (merged, { classes, id }) => [
        ...merged,
        ...classesToArray(classes).map((c) => ({ ...c, enrollmentID: id })),
      ],
      [],
    )

    let upcoming = allClasses.find(({ startTime }) => allowJoinClass(startTime))

    if (!upcoming) {
      return undefined
    }

    return {
      ...upcoming,
      enrollmentID: upcoming.enrollmentID,
      userType,
    }
  }

  deleteRegistration = async (id) => {
    const success = await cancelRegistration(id)

    if (success) {
      const enrollments = this.state.enrollments
      enrollments.splice(
        enrollments.findIndex((enrollment) => enrollment.id === id),
        1,
      )
      await this.setState({ enrollments })
      const { livDemyID, courseURL, user } = this.state
      this.init({ livDemyID, courseURL, user })
    }

    return success
  }

  classFeedback = () => {}

  followTeacher = async () => {
    const { livDemyID, doFollow } = this.state

    const success = await (doFollow
      ? unfollowTeacher(livDemyID)
      : followTeacherRequest(livDemyID))

    if (success) {
      await this.setState({ doFollow: !this.state.doFollow })
    }
  }
}
